/**
 * Servicio que se encarga de registrar el rastreo de
 * los procesos en el aplicativo.
 * JMM-2018-11-01
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service'; 

@Injectable()
export class RastreoService {

  getUsuarioId: any = localStorage.getItem('usuarioid'); // Obtine el id del usuario registrado
  PATH = new ConfigService().obtenerPath();


  constructor(
    private http  : Http,
    private _key   : KeyService
  ) {}


  /**
   * Enviar rastreo
   * JMM-2018-11-01
   */
  setRastreo(cambio, opcion)
  {
    let datos = {
      usuarioid: this.getUsuarioId,
      cambio: cambio,
      opcion: opcion
    }

    let url = this.PATH + '/api/admin/rastreo';
    return this.http.post(url, datos, {headers:this._key.head()}).map(resp => resp.json());
  }// .setRastreo(rastreo:any)


  /**
   * Obtener listado de rastreo
   * JACP-2018-11-16
   */
  getRastreo()
  {
    let url = this.PATH + '/api/admin/rastreo';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRastreo()


  /** 
   * Permite obtener los registros segun las peticiones realizadas 
   */
  obtenerFiltro(info)
  {
    let usuarioid   = info.usuarioid != '' ? info.usuarioid : null;
    let opcion      = info.opcion    != '' ? info.opcion    : null;
    let fecha       = info.fecha     != '' ? info.fecha     : null;
    let fecha_final = info.fecha_final != '' ? info.fecha_final : null;

    let url = this.PATH + '/api/admin/obtenerfiltrorastreo/'+usuarioid+'/'+opcion+'/'+fecha+'/'+fecha_final;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/rastreo/rastreo.service.ts